// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".staked-status-container[data-v-0464aaac] {\n  max-width: 500px;\n}\n.border-container[data-v-0464aaac] {\n  border: 2px solid var(--v-selectBorder-base);\n}", ""]);
// Exports
module.exports = exports;
